import React from 'react';
import Button from '../common/Button';
import Card from '../common/Card';

const ProgramDetails = ({ program }) => {
  if (!program) {
    return null;
  }

  return (
    <Card className="mb-6 overflow-hidden" shadow="lg">
      <div className="-mx-6 -mt-6 mb-6">
        <div className="bg-primary-dark text-white py-4 px-6">
          <h3 className="font-bold text-xl">Program Details</h3>
        </div>

        {program.image && (
          <div className="relative h-44 bg-primary-dark overflow-hidden">
            <img
              src={program.image}
              alt={program.title}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/images/programs/programs-hero-bg.jpg';
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/70 via-transparent to-transparent"></div>
            <div className="absolute bottom-3 left-4 h-11 w-11 rounded-full bg-white/90 text-primary flex items-center justify-center text-xl shadow-md">
              {program.icon}
            </div>
          </div>
        )}
      </div>

      <div className="space-y-4">
        <div className="flex justify-between border-b border-gray-200 pb-2 gap-4">
          <span className="text-gray-600">Duration:</span>
          <span className="font-medium text-right">{program.duration}</span>
        </div>
        <div className="flex justify-between border-b border-gray-200 pb-2 gap-4">
          <span className="text-gray-600">Next Cohort:</span>
          <span className="font-medium text-right">{program.nextCohortStart}</span>
        </div>
        <div className="flex justify-between border-b border-gray-200 pb-2 gap-4">
          <span className="text-gray-600">Schedule:</span>
          <span className="font-medium text-right">{program.schedule}</span>
        </div>
        <div className="flex justify-between border-b border-gray-200 pb-2 gap-4">
          <span className="text-gray-600">Price:</span>
          <span className="font-medium text-right">{program.price}</span>
        </div>
        <div className="flex justify-between pb-2 gap-4">
          <span className="text-gray-600">Status:</span>
          <span className="font-medium text-green-600 text-right">{program.enrollmentStatus}</span>
        </div>
      </div>

      <div className="mt-6 space-y-3">
        <Button
          variant="secondary"
          size="lg"
          to="/apply"
          className="w-full"
        >
          Apply Now
        </Button>
        <Button
          variant="outline-primary"
          size="lg"
          to="/contact"
          className="w-full"
        >
          Request Information
        </Button>
      </div>
    </Card>
  );
};

export default ProgramDetails;
